import React from 'react';

var HeaderWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'pgc-game-header' }, children);
};

export { HeaderWr };
